<template>
  <div class="content">
    <section class="container testimonials has-text-centered">
      <carousel :autoplay="true" :autoplayTimeout="10000" :autoplayHoverPause="true" :loop="true" :navigationEnabled="true"
            :paginationColor="'white'" :paginationActiveColor="'white'" :perPage="1" :perPageCustom="[[768, 1]]">
        <slide v-for="testimonial in testimonials" v-bind:key="testimonial.name">
          <p class="testimonial">{{testimonial.message}}</p>
          <p class="testimonial-name">{{testimonial.name}}</p>
        <div class="home-pic">
          <figure class="image testimonial-image">
            <img :src="testimonial.image" alt="Phil Makepeace" />
          </figure>
        </div>
        </slide>
      </carousel>
    </section>
    <section class="container has-text-centered">     
      <p>Phil Makepeace provides chess coaching for all ages including school clubs in London. I have consistently delivered fun and educational chess tuition to individuals, groups and schools since 2013.</p>
      <p>Whether you are already a serious player or just getting started, lessons will be carefully designed around your individual chess needs.</p>
      <button onclick="location.href='http://makepeacewithchess.com/contact'" class="button is-primary">Get in touch!</button>
      <button onclick="location.href='http://makepeacewithchess.com/services'" class="button is-primary">Services</button>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      testimonials: [
        {
          image: require('../assets/Phil1.png'),
          message: 'It is truly delightful when your 6 year old is able to educate you with genuine enthusiasm on his learnings during chess classes.',
          name: 'Abbi H, London'
        },
        {
          image: require('../assets/Phil3.png'),
          message: 'Enthusiastic, pragmatic and reliable chess training. Having an approach based on practical advice which can be incorporated immediately into the student\'s game has benefitted me.',
          name: 'Simon H, London W13'
        },
        {
          image: require('../assets/Phil4.jpg'),
          message: 'Genuinely enthusiastic and caring teaching. It has been tailored to the weaknesses of my game and greatly helped me improve.',
          name: 'Benjamin P, London E14'
        },
        {
          image: require('../assets/Phil6.png'),
          message: 'I have found that useful quality in a teacher of being able to understand, follow and explain exactly what I want to be learning about.',
          name: 'David S, London'
        },
        {
          image: require('../assets/Phil8.jpg'),
          message: 'I\'m always so impressed by the perfect blend of fun and professionalism … especially considering the fact that we don\'t even live on the same continent!',
          name: 'Kelly H, Toronto'
        }
      ]
    }
  },
  head: {
    meta: [
      { name: 'description', content: 'Fun and engaging chess classes in schools around London. We also provide one-on-one chess coaching to help players take their game to the next level.' }
    ]
  }
}
</script>

<style lang="sass">

.section.main
  padding-top: 24px

.testimonials
  padding-top: 0

.testimonial-name
  font-size: 0.75rem
  font-weight: bold

.chess-list li
  margin-bottom: 12px
.chess-list li:before
  font-family: 'arial unicode ms'
  content: "\2659"
  margin-right: 0.2em

.container.testimonials
  padding-left: 20px
  padding-right: 20px

.home-pic
  max-width: 460px
  margin: auto
  margin-top: 32px

.testimonial-image-caption
  font-size: 0.75rem
  font-style: italic

.testimonial-image-caption a
  color: black

.VueCarousel-pagination
  height: 4px

</style>



// WEBPACK FOOTER //
// Home.vue?a48f3ce2